<script setup lang="ts">
import { useRoute } from "vue-router";
import AppIcon from "./AppIcon.vue";

/** Los tres lugares, abajo, donde alcanza el pulgar. Solo en pantallas chicas. */
const route = useRoute();

const LUGARES = [
  { to: "/", label: "Tareas", icon: "list", activo: (p: string) => p === "/" || p.startsWith("/tareas") },
  { to: "/historial", label: "Historial", icon: "history", activo: (p: string) => p.startsWith("/historial") || p.startsWith("/corridas") },
  { to: "/ajustes", label: "Ajustes", icon: "settings", activo: (p: string) => p.startsWith("/ajustes") || p.startsWith("/usuarios") || p.startsWith("/bitacora") },
];
</script>

<template>
  <nav
    class="pb-safe px-safe fixed inset-x-0 bottom-0 z-30 border-t border-separator bg-[var(--sidebar)] backdrop-blur-xl md:hidden"
    aria-label="Secciones"
  >
    <div class="mx-auto grid h-[3.6rem] max-w-md grid-cols-3">
      <RouterLink
        v-for="lugar in LUGARES"
        :key="lugar.to"
        :to="lugar.to"
        class="toque flex flex-col items-center justify-center gap-0.5 text-[11px] font-medium transition-colors"
        :class="lugar.activo(route.path) ? 'text-accent' : 'text-tertiary'"
      >
        <AppIcon :name="lugar.icon" :size="21" />
        {{ lugar.label }}
      </RouterLink>
    </div>
  </nav>
</template>
